import { ICategoryDto } from "./CategoryDto";
import { IProductDto } from "./ProductDto";

export interface ICatalogDto {
    categories: ICategoryDto[] | null;
    products: IProductDto[] | null;
}

export class CatalogDto implements ICatalogDto {
    public categories: ICategoryDto[] | null;
    public products: IProductDto[] | null;
    constructor() {
        this.categories = new Array<ICategoryDto>();
        this.products = new Array<IProductDto>();
    }
}